import React from "react";
import EtpayWidget from "./components/EtpayWidget/EtpayWidget";
import ErrorPage from "./components/ErrorPage/ErrorPage";

const App: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const sessionToken = params.get("session");

  if (!sessionToken) {
    return (
      <ErrorPage message="Parámetro 'session' requerido no encontrado en la URL." />
    );
  }

  return <EtpayWidget sessionToken={sessionToken} />;
};

export default App;
